import { IToken } from 'interfaces/token';
import { IUserRequest } from 'interfaces/user';
import { ICompanyRequest } from 'interfaces/companies';
import axios, { Response } from 'services';
import { formateUserRequestData } from 'utils/formatter';

export interface ILoginPayload {
	email: string;
	password: string;
	fingerprint?: string;
};
export const login = (payload: ILoginPayload): Response<IToken> => {
	return axios.post(`/auth/login`, payload);
};

interface IRegistrationPayload {
	user: IUserRequest;
	company: ICompanyRequest;
}
export const registration = (data: IRegistrationPayload): Response<void> => {
	const { user, company } = data;
	if (!company.kpp) {
		delete company.kpp
	}
	const payload = {
		user: formateUserRequestData(user),
		company
	}
	return axios.post(`/registration`, payload);
};

interface IResetPasswordCodePayload {
	email: string;
}
export const getResetPasswordToken = (payload: IResetPasswordCodePayload): Response<void> => {
	return axios.post(`/auth/send_reset_token`, payload);
};

interface IResetPasswordPayload {
	password: string;
	confirmPassword: string;
	resetToken: string;
}
export const resetPassword = (data: IResetPasswordPayload): Response<void> => {
	const { password, confirmPassword, resetToken } = data;
	const payload = {
		password,
		password_confirmation: confirmPassword
	}
	return axios.post(`/auth/reset_password/${resetToken}`, payload);
};

export const refreshToken = (fingerprint: string): Response<IToken> => {
	return axios.post(`/auth/refresh_tokens`, { fingerprint });
};
